export const JSON_CONTENT_TYPE = 'application/json; charset=utf-8';
const CONTENT_TYPE_HEADER = 'Content-Type';

const getHeaderKey = (headers, headerName) => (
	Object.keys(headers).find(key => key.toLowerCase() === headerName.toLowerCase())
);

const removeHeader = (headers, headerName) => {
	const headerKey = getHeaderKey(headers, headerName);
	if (headerKey) {
		delete headers[headerKey];
	}
};

export const isFormDataPayload = (payload) => (
	typeof FormData !== 'undefined' && payload instanceof FormData
);

export const applyRequestContentType = (request) => {
	const headers = { ...(request?.headers || {}) };

	if (request?.data === undefined || request?.data === null) {
		return { ...request, headers };
	}

	if (isFormDataPayload(request.data)) {
		removeHeader(headers, CONTENT_TYPE_HEADER);
		return { ...request, headers };
	}

	headers[getHeaderKey(headers, CONTENT_TYPE_HEADER) || CONTENT_TYPE_HEADER] = JSON_CONTENT_TYPE;
	return { ...request, headers };
};
